import { AppInfo } from '../../../../constants';

export const AUTH_LOCAL_STORAGE_KEY = `${AppInfo.companyName}-auth`;
export const ROLE_LOCAL_STORAGE_KEY = `${AppInfo.companyName}-role`;
export const AUTH_LOCAL_COOKIE_KEY = `session_token`;

export const SIGN_IN_PATH = '/sign-in';
export const SIGN_UP_PATH = '/sign-up';
export const SIGN_UP_VERIFICATION_PATH = '/sign-up-verification';
export const SIGN_UP_ACCOUNT_TYPE_PATH = '/sign-up-account-type';
export const SIGN_UP_COMPLETE_PATH = '/sign-up-complete';
export const RESET_PASSWORD_PATH = '/reset-password';
export const FORGET_PASSWORD_PATH = '/forget-password';
export const FORCE_CHANGE_PASSWORD_PATH = '/force-change-password';
export const ROLES_PATH = '/roles';
export const CREATE_ROLE_PATH = '/roles/new';
export const AUTH_COMPLETE_NEXT_PATH = '/';

export const authRoutes = [
  SIGN_IN_PATH,
  SIGN_UP_PATH,
  SIGN_UP_VERIFICATION_PATH,
  SIGN_UP_ACCOUNT_TYPE_PATH,
  SIGN_UP_COMPLETE_PATH,
  RESET_PASSWORD_PATH,
  FORGET_PASSWORD_PATH,
  FORCE_CHANGE_PASSWORD_PATH,
];

export const CHALLENGE_SESSION_KEY = 'challengeSession';
export const CHALLENGE_USERNAME_KEY = 'challengeUsername';
export const CHALLENGE_EMAIL_KEY = 'challengeEmail';

